export const GET_FEATURES_FLAGS = "GET_FEATURES_FLAGS";
export const GET_FEATURES_FLAGS_SUCCESS = "GET_FEATURES_FLAGS_SUCCESS";
export const GET_FEATURES_FLAGS_ERROR = "GET_FEATURES_FLAGS_ERROR";

export const CREATE_FEATURES_FLAG = "CREATE_FEATURES_FLAG";
export const CREATE_FEATURES_FLAG_SUCCESS = "CREATE_FEATURES_FLAG_SUCCESS";
export const CREATE_FEATURES_FLAG_ERROR = "CREATE_FEATURES_FLAG_ERROR";

export const ENABLE_FEATURES_FLAG = "ENABLE_FEATURES_FLAG";
export const ENABLE_FEATURES_FLAG_SUCCESS = "ENABLE_FEATURES_FLAG_SUCCESS";
export const ENABLE_FEATURES_FLAG_ERROR = "ENABLE_FEATURES_FLAG_ERROR";

export const DISABLE_FEATURES_FLAG = "DISABLE_FEATURES_FLAG";
export const DISABLE_FEATURES_FLAG_SUCCESS = "DISABLE_FEATURES_FLAG_SUCCESS";
export const DISABLE_FEATURES_FLAG_ERROR = "DISABLE_FEATURES_FLAG_ERROR";

export const TOGGLE_FEATURES_FLAGS_ACCOUNTS = "TOGGLE_FEATURES_FLAGS_ACCOUNTS"
export const TOGGLE_FEATURES_FLAGS_ACCOUNTS_SUCCESS = "TOGGLE_FEATURES_FLAGS_ACCOUNTS_SUCCESS"
export const TOGGLE_FEATURES_FLAGS_ACCOUNTS_ERROR = "TOGGLE_FEATURES_FLAGS_ACCOUNTS_ERROR"

export const TOGGLE_FEATURES_FLAGS_ADMIN_USERS = "TOGGLE_FEATURES_FLAGS_ADMIN_USERS"
export const TOGGLE_FEATURES_FLAGS_ADMIN_USERS_SUCCESS = "TOGGLE_FEATURES_FLAGS_ADMIN_USERS_SUCCESS"
export const TOGGLE_FEATURES_FLAGS_ADMIN_USERS_ERROR = "TOGGLE_FEATURES_FLAGS_ADMIN_USERS_ERROR"

export const GET_WHITELISTED_BRANDS_FEATURE_FLAGS = "GET_WHITELISTED_BRANDS_FEATURE_FLAGS"
export const GET_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS = "GET_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS"
export const GET_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR = "GET_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR"

export const CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS = "CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS"
export const CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS = "CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS"
export const CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR = "CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR"

export const DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS = "DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS"
export const DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS = "DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS"
export const DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR = "DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR"